import { Checkbox, Chip, FormControl, InputLabel, ListItemText, MenuItem, Select, Switch, TextField } from '@material-ui/core';
import React, { Component } from 'react';
import {
  getQueryByCat, QREQ_CONDITION, QREQ_CONDITION_BOOL, QREQ_DEVICE, QREQ_DEVICE_ID, QREQ_DEVICE_NO_ID, QREQ_GRAPH, QREQ_NONE,
  QREQ_TAGS, QREQ_THREE, QUERY_CONDITION_FORMAT, QUERY_CONDITION_MATH, QUERY_CONDITION_BOOL, TYPE_GRAPH_PIE
} from '../../../lib/components/Preference';
import { TextInputTag } from '../../../lib/components/textInputTag';

/* Object Json */
import { parse, safeDeepDel, safeDeepGet, safeDeepGetWithType, safeDeepSet, stringify } from 'iotera-base/json';
import { isFunction, isNumber, isObject, isEmpty, isArray } from 'iotera-base/object';
import { sortObject } from '../../../lib/components/formatter';

export class SelectionQuery extends Component {
  constructor(props) {
    super(props);
    // TODO handle reload
    let queryType = safeDeepGetWithType(props, ['query_type'], QREQ_NONE)
    const _parent = safeDeepGet(props, ['_parent']);
    let devices = {};
    devices = {
      devices_label: safeDeepGetWithType(_parent, ['state', 'devices_label'], {}),
      devices: safeDeepGetWithType(_parent, ['state', 'devices'], {}),
      sensors: sortObject(safeDeepGetWithType(_parent, ['state', 'sensors'], {})),
      tags: safeDeepGetWithType(_parent, ['state', 'tags'], [])
    }
    let varFSensor = safeDeepGetWithType(_parent, ['state', 'model', 'sensor'], '');
    let varFConfig = safeDeepGetWithType(_parent, ['state', 'model', 'config'], '');
    let varFParam = safeDeepGetWithType(_parent, ['state', 'model', 'param'], '');
    this.state = {
      queryType,
      devices,
      varFSensor,
      varFConfig,
      varFParam
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeArr = this.handleChangeArr.bind(this);
    this.handleValidateArr = this.handleValidateArr.bind(this);
    this.handleChangeToggle = this.handleChangeToggle.bind(this);
  }

  handleChangeArr = (id, prefix, event) => {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let checkSubmitable = safeDeepGet(_props, ['checkSubmitable'])
    let finalData = safeDeepGetWithType(_state, ['finalData'], {});
    finalData.subparam_label = event;
    let subparam = safeDeepGetWithType(_state, ['varFSubparam'], []);
    if (isFunction(checkSubmitable)) {
      if (event.length > 0 && event.length !== subparam.length) {
        checkSubmitable('varValue', {});
      } else {
        checkSubmitable('varValue', finalData);
      }
    }
    _this.setState({ [id]: event })
  }

  handleValidateArr = tag => {
    const _props = this.props
    let value = tag[0];
    let firstChar = parseInt(value.charAt(0), 10);
    let _parent = safeDeepGet(_props, ['_parent']);
    if (isNumber(firstChar)) {
      _parent.props.showSingleNotification({ message: 'Penanda tidak boleh diawali oleh angka!', level: 'error' });
    } else if (value.length > 16) {
      _parent.props.showSingleNotification({ message: 'Penanda maksimal 16 karakter!', level: 'error' });
    } else {
      _parent.props.showSingleNotification({ message: 'Penanda tidak boleh diawali huruf besar', level: 'error' });
    }
  }

  handleChange(event) {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const name = safeDeepGetWithType(event, ['target', 'name'], '');
    const value = safeDeepGet(event, ['target', 'value'], '');
    const _parent = safeDeepGet(_props, ['_parent']);
    let finalData = safeDeepGetWithType(_state, ['finalData'], {});
    let checkSubmitable = safeDeepGet(_props, ['checkSubmitable'])
    let _handleChange = safeDeepGet(_props, ['handleChange'])
    if (isFunction(_handleChange)) {
      _handleChange(event)
    }
    const isFunc = isFunction(checkSubmitable);
    if (name === 'varFunc') {
      const valueObj = parse(value);
      finalData = {};
      const varFQuery = safeDeepGetWithType(valueObj, ['value'], '');
      const queryType = safeDeepGetWithType(valueObj, ['type'], '');
      finalData.query = varFQuery;
      finalData.queryType = queryType;
      if (queryType === QREQ_NONE) {
        _this.setState({
          [name]: value,
          queryType,
          finalData,
          varFDevId: null,
          varFSensor: null,
          varFConfig: null,
          varFParam: null,
          varFSubparam: null,
          varFTags: null,
          varFConditionOType: null,
          condition: null,
          true_condition: null,
          false_condition: null,
        });
        if (isFunc) {
          checkSubmitable('varValue', finalData);
        }
      } else if (queryType === QREQ_TAGS) {
        let devices = {
          tags: safeDeepGetWithType(_parent, ['state', 'tags'], [])
        }
        _this.setState({
          [name]: value,
          queryType,
          finalData,
          varFDevId: null,
          varFSensor: null,
          varFConfig: null,
          varFParam: null,
          varFSubparam: null,
          varFTags: null,
          varFConditionOType: null,
          condition: null,
          true_condition: null,
          false_condition: null,
          devices
        });
        if (isFunc) {
          checkSubmitable('varValue', finalData);
        }
      } else {
        let devices = {
          devices_label: safeDeepGetWithType(_parent, ['state', 'devices_label'], {}),
          devices: safeDeepGetWithType(_parent, ['state', 'devices'], {}),
          sensors: sortObject(safeDeepGetWithType(_parent, ['state', 'sensors'], {})),
        }
        _this.setState({
          [name]: value,
          varFQuery,
          queryType,
          varFDevId: null,
          varFSensor: null,
          varFConfig: null,
          varFParam: null,
          varFSubparam: null,
          varFTags: null,
          varFConditionOType: null,
          condition: null,
          true_condition: null,
          false_condition: null,
          devices,
          finalData
        })
        if (isFunc) {
          checkSubmitable('varValue', {});
        }
      }
      _parent.setState({ finalData })
    } else {
      let queryType = safeDeepGetWithType(_state, ['queryType'], QREQ_NONE)
      finalData.queryType = queryType;
      if (queryType === QREQ_NONE) {
        return;
      } else if (queryType === QREQ_CONDITION_BOOL || queryType === QREQ_CONDITION) {
        finalData[name] = value;
        _this.setState({
          [name]: value,
          queryType,
          finalData
        })
        if (isFunc) {
          checkSubmitable('varValue', finalData);
        }
        return;
      }
      if (name === 'varFDevId') {
        if (queryType === QREQ_DEVICE_ID || queryType === QREQ_DEVICE || queryType === QREQ_GRAPH || queryType === QREQ_THREE) {
          safeDeepSet(finalData, ['device_id'], value)
          safeDeepDel(finalData, ['sensor'])
          safeDeepDel(finalData, ['config'])
          safeDeepDel(finalData, ['param'])
          safeDeepDel(finalData, ['subparam'])
        }
        if (queryType === QREQ_DEVICE_ID) {
          _this.setState({
            [name]: value,
            finalData,
            varFSensor: null,
            varFConfig: null,
            varFParam: null,
            varFSubparam: null,
            varFSubparam1: null,
            varFSubparam2: null,
            varFSubparam3: null
          })
          if (isFunc) {
            checkSubmitable('varValue', finalData);
          }
        } else {
          _this.setState({
            [name]: value,
            finalData,
            varFSensor: null,
            varFConfig: null,
            varFParam: null,
            varFSubparam: null,
            varFSubparam1: null,
            varFSubparam2: null,
            varFSubparam3: null
          })
        }
      } else if (name === 'varFSensor') {
        if (queryType === QREQ_DEVICE || queryType === QREQ_GRAPH || queryType === QREQ_DEVICE_NO_ID || queryType === QREQ_THREE) {
          safeDeepSet(finalData, ['sensor'], value)
          safeDeepDel(finalData, ['config'])
          safeDeepDel(finalData, ['param'])
          safeDeepDel(finalData, ['subparam'])
        }
        _this.setState({
          [name]: value,
          finalData,
          varFConfig: null,
          varFParam: null,
          varFSubparam: null,
          varFSubparam1: null,
          varFSubparam2: null,
          varFSubparam3: null
        })
        if (isFunc) {
          checkSubmitable('varValue', {});
        }
      } else if (name === 'varFConfig') {
        if (queryType === QREQ_DEVICE || queryType === QREQ_GRAPH || queryType === QREQ_DEVICE_NO_ID || queryType === QREQ_THREE) {
          safeDeepSet(finalData, ['config'], value)
          safeDeepDel(finalData, ['param'])
          safeDeepDel(finalData, ['subparam'])
        }
        _this.setState({
          [name]: value,
          finalData,
          varFParam: null,
          varFSubparam: null,
          varFSubparam1: null,
          varFSubparam2: null,
          varFSubparam3: null
        })
        if (isFunc) {
          checkSubmitable('varValue', {});
        }
      } else if (name === 'varFParam') {
        if (queryType === QREQ_DEVICE || queryType === QREQ_GRAPH || queryType === QREQ_DEVICE_NO_ID || queryType === QREQ_THREE) {
          safeDeepSet(finalData, ['param'], value)
          safeDeepDel(finalData, ['param_label'])
          safeDeepDel(finalData, ['subparam'])
          safeDeepDel(finalData, ['subparam_label'])
        }
        let varFSensor = safeDeepGetWithType(_state, ['varFSensor'], '');
        let varFConfig = safeDeepGetWithType(_state, ['varFConfig'], '');
        let varFParam = value;
        let currParam = '';
        if (queryType === QREQ_DEVICE || queryType === QREQ_GRAPH || queryType === QREQ_THREE) {
          let devices = safeDeepGetWithType(_state, ['devices', 'devices'], {});
          let varFDevId = safeDeepGetWithType(_state, ['varFDevId'], '');
          currParam = devices[varFDevId][varFSensor][varFConfig][varFParam];
        } else if (queryType === QREQ_DEVICE_NO_ID) {
          let sensors = safeDeepGetWithType(_state, ['devices', 'sensors'], {});
          currParam = sensors[varFSensor][varFConfig][varFParam];
        }
        if (isObject(currParam)) {
          if (isFunc) {
            checkSubmitable('varValue', {});
          }
        } else {
          if (isFunc) {
            checkSubmitable('varValue', finalData);
          }
        }
        _this.setState({
          [name]: value,
          finalData,
          varFSubparam: null,
          varFSubparam1: null,
          varFSubparam2: null,
          varFSubparam3: null
        })
      } else if (name === 'varFParamLabel') {
        if (queryType === QREQ_GRAPH) {
          finalData.param_label = value;
        }
        _this.setState({
          [name]: value,
          finalData
        })
        if (isFunc) {
          checkSubmitable('varValue', finalData);
        }
      } else if (name === 'varFSubparam') {
        if (queryType === QREQ_DEVICE || queryType === QREQ_GRAPH || queryType === QREQ_DEVICE_NO_ID || queryType === QREQ_THREE) {
          finalData.subparam = value;
          if (value === '_no_subparam@sa!randsodamdas_') {
            safeDeepDel(finalData, ['subparam'])
          }
        }
        if (isFunc) {
          if (isArray(value) && value.length < 1) {
            checkSubmitable('varValue', {});
          } else {
            checkSubmitable('varValue', finalData);
          }
        }
        _this.setState({
          [name]: value,
          finalData
        })
      } else if (name === 'varFTags') {
        const valueArr = safeDeepGetWithType(event, ['target', 'value'], []);
        finalData.tags = valueArr;
        if (isFunc) {
          checkSubmitable('varValue', finalData);
        }
        _this.setState({
          [name]: valueArr
        })
      } else {
        _this.setState({
          [name]: value
        })
      }
      if (queryType === QREQ_THREE) {
        let subparamTemp1 = safeDeepGetWithType(_state, ['varFSubparam1'], '')
        let subparamTemp2 = safeDeepGetWithType(_state, ['varFSubparam2'], '')
        let subparamTemp3 = safeDeepGetWithType(_state, ['varFSubparam3'], '')
        if (name === 'varFSubparam1') {
          if (subparamTemp2 === '' || subparamTemp3 === '') {
            if (isFunc) {
              checkSubmitable('varValue', {});
            }
          } else {
            finalData.subparam = [value, subparamTemp2, subparamTemp3];
            if (isFunc) {
              checkSubmitable('varValue', finalData);
            }
          }
          _this.setState({
            [name]: value,
            finalData
          })
        } else if (name === 'varFSubparam2') {
          if (subparamTemp1 === '' || subparamTemp3 === '') {
            if (isFunc) {
              checkSubmitable('varValue', {});
            }
          } else {
            finalData.subparam = [subparamTemp1, value, subparamTemp3];
            if (isFunc) {
              checkSubmitable('varValue', finalData);
            }
          }
          _this.setState({
            [name]: value,
            finalData
          })
        } else if (name === 'varFSubparam3') {
          if (subparamTemp2 === '' || subparamTemp1 === '') {
            if (isFunc) {
              checkSubmitable('varValue', {});
            }
          } else {
            finalData.subparam = [subparamTemp1, subparamTemp2, value];
            if (isFunc) {
              checkSubmitable('varValue', finalData);
            }
          }
          _this.setState({
            [name]: value,
            finalData
          })
        }
      }
      _parent.setState({ finalData })
    }
  }

  handleChangeToggle = (value) => {
    const _this = this
    const _props = _this.props
    const changeValue = !value;
    _this.setState({ varFConditionOType: changeValue, true_condition: null, false_condition: null })
    let checkSubmitable = safeDeepGet(_props, ['checkSubmitable'])
    if (isFunction(checkSubmitable))
      checkSubmitable('varValue', {});
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let _parent = safeDeepGet(_props, ['_parent']);
    let _var = safeDeepGetWithType(_parent, ['state', '_var'], {});
    let allDevices = safeDeepGetWithType(_state, ['devices'], {});
    let currCat = safeDeepGetWithType(_parent, ['state', 'finalCat'], '');
    let varFunc = safeDeepGetWithType(_state, ['varFunc'], '');
    let condition = safeDeepGetWithType(_state, ['condition'], '');
    let true_condition = safeDeepGet(_state, ['true_condition'], '');
    let false_condition = safeDeepGet(_state, ['false_condition'], '');
    let varFConditionOType = safeDeepGet(_state, ['varFConditionOType'], true);
    let outputType = 'string'
    if (!varFConditionOType)
      outputType = 'number'
    let varFDevId = safeDeepGetWithType(_state, ['varFDevId'], '');
    let varFTags = safeDeepGetWithType(_state, ['varFTags'], []);
    let varFSensor = safeDeepGetWithType(_state, ['varFSensor'], '');
    let varFConfig = safeDeepGetWithType(_state, ['varFConfig'], '');
    let varFParam = safeDeepGetWithType(_state, ['varFParam'], '');
    let varFParamLabel = safeDeepGetWithType(_state, ['varFParamLabel'], '');
    let varFSubparam = safeDeepGetWithType(_state, ['varFSubparam'], '');
    let varFSubparam1 = safeDeepGetWithType(_state, ['varFSubparam1'], '');
    let varFSubparam2 = safeDeepGetWithType(_state, ['varFSubparam2'], '');
    let varFSubparam3 = safeDeepGetWithType(_state, ['varFSubparam3'], '');
    let varFQuery = safeDeepGetWithType(_state, ['varFQuery'], '');
    let queryType = safeDeepGetWithType(_state, ['queryType'], QREQ_NONE);
    let varFSubparamLabel = safeDeepGetWithType(_state, ['varFSubparamLabel'], []);
    if (queryType === QREQ_GRAPH && currCat !== TYPE_GRAPH_PIE) {
      varFSubparam = safeDeepGetWithType(_state, ['varFSubparam'], []);
    }
    let devices = safeDeepGetWithType(allDevices, ['devices'], {});
    let sensors = safeDeepGetWithType(allDevices, ['sensors'], {});
    let tags = safeDeepGetWithType(allDevices, ['tags'], []);
    let devices_label = safeDeepGetWithType(allDevices, ['devices_label'], {});
    let menuDevices = []
    for (let device in devices) {
      let device_label = safeDeepGetWithType(devices_label, [device], '')
      menuDevices.push(
        <MenuItem key={device} value={device} >{device_label}</MenuItem>
      )
    }
    let menuSensors = []
    if ((queryType === QREQ_DEVICE || queryType === QREQ_GRAPH || queryType === QREQ_THREE) && varFDevId !== '') {
      const currDevice = safeDeepGetWithType(devices, [varFDevId], {});
      if (isObject(currDevice) && !isEmpty(currDevice)) {
        for (let sensor in currDevice) {
          menuSensors.push(
            <MenuItem key={sensor} value={sensor} >{sensor}</MenuItem>
          )
        }
      }
    }
    if (queryType === QREQ_DEVICE_NO_ID) {
      for (let sensor in sensors) {
        menuSensors.push(
          <MenuItem key={sensor} value={sensor} >{sensor}</MenuItem>
        )
      }
    }
    let menuConfigs = []
    if ((queryType === QREQ_DEVICE || queryType === QREQ_GRAPH || queryType === QREQ_THREE) && varFDevId !== '' && varFSensor !== '') {
      const currSensor = safeDeepGetWithType(devices, [varFDevId, varFSensor], {});
      if (isObject(currSensor) && !isEmpty(currSensor))
        for (let config in currSensor) {
          menuConfigs.push(
            <MenuItem key={config} value={config} >{config}</MenuItem>
          )
        }
    }
    if (queryType === QREQ_DEVICE_NO_ID && varFSensor !== '') {
      const currSensor = safeDeepGetWithType(sensors, [varFSensor], {});
      if (isObject(currSensor) && !isEmpty(currSensor))
        for (let config in currSensor) {
          menuConfigs.push(
            <MenuItem key={config} value={config} >{config}</MenuItem>
          )
        }
    }
    let menuParams = []
    if ((queryType === QREQ_DEVICE || queryType === QREQ_GRAPH || queryType === QREQ_THREE) && varFDevId !== '' &&
      varFSensor !== '' && varFConfig !== '') {
      const currConfig = safeDeepGetWithType(devices, [varFDevId, varFSensor, varFConfig], {});
      if (isObject(currConfig) && !isEmpty(currConfig))
        for (let param in currConfig) {
          menuParams.push(
            <MenuItem key={param} value={param} >{param}</MenuItem>
          )
        }
    }

    if (queryType === QREQ_DEVICE_NO_ID && varFSensor !== '' && varFConfig !== '') {
      const currConfig = safeDeepGetWithType(sensors, [varFSensor, varFConfig], {});
      if (isObject(currConfig) && !isEmpty(currConfig))
        for (let param in currConfig) {
          menuParams.push(
            <MenuItem key={param} value={param} >{param}</MenuItem>
          )
        }
    }
    let menuSubparams = []
    let showParamLabel = false;
    if ((queryType === QREQ_DEVICE || queryType === QREQ_THREE || currCat === TYPE_GRAPH_PIE) && varFDevId !== '' && varFSensor !== '' && varFConfig !== '' && varFParam !== '') {
      const currParam = safeDeepGetWithType(devices, [varFDevId, varFSensor, varFConfig, varFParam], {});
      if (isObject(currParam) && !isEmpty(currParam)) {
        for (let subparam in currParam) {
          menuSubparams.push(
            <MenuItem key={subparam} value={subparam} >{subparam}</MenuItem>
          )
        }
      }
    }
    if (queryType === QREQ_GRAPH && currCat !== TYPE_GRAPH_PIE && varFDevId !== '' && varFSensor !== '' && varFConfig !== '' && varFParam !== '') {
      const currParam = safeDeepGetWithType(devices, [varFDevId, varFSensor, varFConfig, varFParam], {});
      if (isObject(currParam) && !isEmpty(currParam)) {
        for (let subparam in currParam) {
          menuSubparams.push(
            <MenuItem key={subparam} value={subparam}>
              <Checkbox color='primary' checked={varFSubparam.indexOf(subparam) > -1} />
              <ListItemText primary={subparam} />
            </MenuItem>
          )
        }
      } else {
        showParamLabel = true;
      }
    }
    if (queryType === QREQ_DEVICE_NO_ID && varFSensor !== '' && varFConfig !== '' && varFParam !== '') {
      const currParam = safeDeepGetWithType(sensors, [varFSensor, varFConfig, varFParam], {});
      if (isObject(currParam) && !isEmpty(currParam)) {
        for (let subparam in currParam) {
          menuSubparams.push(
            <MenuItem key={subparam} value={subparam} >{subparam}</MenuItem>
          )
        }
      }
    }
    if (queryType !== QREQ_GRAPH && queryType !== QREQ_THREE)
      if (menuSubparams.length > 0)
        menuSubparams = [<MenuItem key={'_no_subparam@sa!randsodamdas_'} value={'_no_subparam@sa!randsodamdas_'}>
          <em>No Subparam</em></MenuItem>].concat(menuSubparams)
    let menuTags = []
    for (let i = 0; i < tags.length; i++) {
      let tag = tags[i];
      menuTags.push(
        <MenuItem key={tag} value={tag}>
          <Checkbox color='primary' checked={varFTags.indexOf(tag) > -1} />
          <ListItemText primary={tag} />
        </MenuItem>
      )
    }
    let menuItems = []
    let query = getQueryByCat(currCat);
    for (let i = 0; i < query.length; i++) {
      const currQuery = query[i];
      const value = safeDeepGetWithType(currQuery, ['value'], '')
      const name = safeDeepGetWithType(currQuery, ['name'], '')
      const type = safeDeepGetWithType(currQuery, ['query_type'], '')
      const selectorName = safeDeepGetWithType(currQuery, ['selector_name'], '')
      let func = {
        value,
        type
      }
      if (selectorName !== '') {
        menuItems.push(
          <MenuItem disabled key={`_!dasdsaSvsaasdas+dasda==${selectorName}`} value="_!dasdsaSvsaasdas+dasda==">
            <em>{selectorName}</em>
          </MenuItem>
        )
      }
      menuItems.push(
        <MenuItem key={stringify(func)} value={stringify(func)}>{name}</MenuItem>
      )
    }
    let menuConditions = []
    if (queryType === QREQ_CONDITION_BOOL) {
      for (let key in _var) {
        menuConditions.push(
          <MenuItem key={key} value={key} >{key}</MenuItem>
        )
      }
    }
    let helperText = 'Contoh : {var_a} * 2 > {var_b} + {var_c}'
    if (varFQuery === QUERY_CONDITION_FORMAT) {
      helperText = 'Contoh : Perangkat {var_label}'
    } else if (varFQuery === QUERY_CONDITION_MATH) {
      helperText = 'Contoh : {var_a} * 2 - {var_b} - {var_c}'
    } else if (varFQuery === QUERY_CONDITION_BOOL) {
      helperText = 'Contoh : "{var_a} * 2 > {var_b} + {var_c}", jika terpenuhi akan mengembalikan nilai "true"'
    }
    let pattern = new RegExp("^[A-Za-z][A-Za-z0-9_ ]{0,15}$"); // regex min 1 char, first letter not number, max length 15
    return (
      <div>
        {_props.query_type === undefined &&
          <FormControl required style={{ minWidth: '100%', marginTop: 10 }} >
            <InputLabel>Query</InputLabel>
            <Select
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              margin='dense'
              value={varFunc}
              onChange={_this.handleChange}
              inputProps={{
                name: 'varFunc'
              }}
            >
              {menuItems}
            </Select>
          </FormControl>
        }
        {queryType === QREQ_CONDITION_BOOL &&
          <div>
            <FormControl required style={{ minWidth: '100%' }} >
              <TextField
                label="Condition"
                value={condition}
                autoFocus
                onChange={_this.handleChange}
                type="string"
                margin='dense'
                inputProps={{ name: 'condition' }}
                helperText={helperText}
              />
            </FormControl>
            <FormControl required style={{ minWidth: '100%' }} >
              <span>
                <i>Number</i>
                <Switch checked={varFConditionOType} color="primary" onChange={() => _this.handleChangeToggle(varFConditionOType)} />
                <i>String</i>
              </span>
            </FormControl>
            <FormControl required style={{ minWidth: '45%', marginRight: 10 }} >
              <TextField
                label="True"
                value={true_condition}
                autoFocus
                onChange={_this.handleChange}
                type={outputType}
                margin='dense'
                inputProps={{ name: 'true_condition' }}
              />
            </FormControl>
            <FormControl required style={{ minWidth: '45%', marginRight: 10 }} >
              <TextField
                label="False"
                value={false_condition}
                autoFocus
                onChange={_this.handleChange}
                type={outputType}
                margin='dense'
                inputProps={{ name: 'false_condition' }}
              />
            </FormControl>
          </div>
        }
        {queryType === QREQ_CONDITION &&
          <div>
            <FormControl required style={{ minWidth: '100%' }} >
              <TextField
                label="Keluaran"
                value={condition}
                autoFocus
                onChange={_this.handleChange}
                type="string"
                margin='dense'
                inputProps={{ name: 'condition' }}
                helperText={helperText}
              />
            </FormControl>
          </div>
        }
        {queryType === QREQ_TAGS &&
          <div>
            <h5 style={{ marginTop: 15 }}>Set all tags empty to query from all devices</h5>
            <FormControl style={{ minWidth: '100%', marginTop: 10 }}  >
              <InputLabel>Tags</InputLabel>
              <Select
                multiple
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                value={varFTags}
                onChange={_this.handleChange}
                inputProps={{
                  name: 'varFTags'
                }}
                renderValue={selected => (
                  <div >
                    {selected.map(value => (
                      <Chip key={value} label={value} style={{ marginLeft: 5 }} />
                    ))}
                  </div>
                )}
              >
                {menuTags}
              </Select>
            </FormControl>
          </div>
        }
        {
          (queryType === QREQ_DEVICE || queryType === QREQ_GRAPH || queryType === QREQ_DEVICE_ID || queryType === QREQ_THREE) &&
          <FormControl required style={{ minWidth: '100%', marginTop: 10 }} >
            <InputLabel>Perangkat</InputLabel>
            <Select
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}

              value={varFDevId}
              onChange={_this.handleChange}
              inputProps={{
                name: 'varFDevId'
              }}
            >
              {menuDevices}
            </Select>
          </FormControl>
        }
        {
          menuSensors.length > 0 &&
          <FormControl required style={{ minWidth: '100%', marginTop: 10 }} >
            <InputLabel>Sensor</InputLabel>
            <Select
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              value={varFSensor}
              onChange={_this.handleChange}
              inputProps={{
                name: 'varFSensor'
              }}
            >
              {menuSensors}
            </Select>
          </FormControl>
        }
        {
          menuConfigs.length > 0 &&
          <FormControl required style={{ minWidth: '100%', marginTop: 10 }} >
            <InputLabel>Config</InputLabel>
            <Select
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              value={varFConfig}
              onChange={_this.handleChange}
              inputProps={{
                name: 'varFConfig'
              }}
            >
              {menuConfigs}
            </Select>
          </FormControl>
        }
        {
          menuParams.length > 0 &&
          <div>
            <FormControl required style={{ minWidth: '100%', marginTop: 10 }} >
              <InputLabel>Param</InputLabel>
              <Select
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                value={varFParam}
                onChange={_this.handleChange}
                inputProps={{
                  name: 'varFParam'
                }}
              >
                {menuParams}
              </Select>
            </FormControl>
            {showParamLabel &&
              <FormControl style={{ minWidth: '100%', marginTop: 10 }}  >
                <TextField
                  type="string"
                  margin='dense'
                  value={varFParamLabel}
                  inputProps={{
                    name: 'varFParamLabel'
                  }}
                  label={'Label'}
                  onChange={_this.handleChange}
                />
              </FormControl>
            }
          </div>
        }
        {
          (queryType !== QREQ_THREE && (queryType !== QREQ_GRAPH || currCat === TYPE_GRAPH_PIE) && menuSubparams.length > 0) &&
          <FormControl required style={{ minWidth: '100%', marginTop: 10 }} >
            <InputLabel>Sub Param</InputLabel>
            <Select
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              value={varFSubparam}
              onChange={_this.handleChange}
              inputProps={{
                name: 'varFSubparam'
              }}
            >
              {menuSubparams}
            </Select>
          </FormControl>
        }
        {
          (currCat !== TYPE_GRAPH_PIE && queryType === QREQ_GRAPH && menuSubparams.length > 0) &&
          <div>
            <FormControl style={{ minWidth: '100%', marginTop: 10 }}  >
              <InputLabel>Subparam</InputLabel>
              <Select
                multiple
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                value={varFSubparam}
                onChange={_this.handleChange}
                inputProps={{
                  name: 'varFSubparam'
                }}
                renderValue={selected => (
                  <div >
                    {selected.map(value => (
                      <Chip key={value} label={value} style={{ marginLeft: 5 }} />
                    ))}
                  </div>
                )}
              >
                {menuSubparams}
              </Select>
            </FormControl>
            {varFSubparam.length > 0 &&
              <FormControl style={{ minWidth: '100%', marginTop: 10 }}  >
                <TextInputTag
                  id={'varFSubparamLabel'}
                  value={varFSubparamLabel}
                  label={'Subparam Label'}
                  onChange={_this.handleChangeArr}
                  pattern={pattern}
                  maxTags={varFSubparam.length}
                  onlyUnique={true}
                  addKeys={[9, 13]}
                  placeholder={'Tambah Label'}
                  onValidationReject={_this.handleValidateArr}
                  preventSubmit={false}
                  customTagClass={'react-tagsinput-tag-grey'}
                  textTooltip={'Tiap label harus unik, tidak diawali angka, maksimum 16 karakter.'}
                />
              </FormControl>
            }
          </div>
        }
        {
          (queryType === QREQ_THREE && menuSubparams.length > 0) &&
          <FormControl required style={{ minWidth: '100%', marginTop: 10 }} >
            <InputLabel>Data 1</InputLabel>
            <Select
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              value={varFSubparam1}
              onChange={_this.handleChange}
              inputProps={{
                name: 'varFSubparam1'
              }}
            >
              {menuSubparams}
            </Select>
          </FormControl>
        }
        {
          (queryType === QREQ_THREE && menuSubparams.length > 0) &&
          <FormControl required style={{ minWidth: '100%', marginTop: 10 }} >
            <InputLabel>Data 2</InputLabel>
            <Select
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              value={varFSubparam2}
              onChange={_this.handleChange}
              inputProps={{
                name: 'varFSubparam2'
              }}
            >
              {menuSubparams}
            </Select>
          </FormControl>
        }
        {
          (queryType === QREQ_THREE && menuSubparams.length > 0) &&
          <FormControl required style={{ minWidth: '100%', marginTop: 10 }} >
            <InputLabel>Data 3</InputLabel>
            <Select
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              value={varFSubparam3}
              onChange={_this.handleChange}
              inputProps={{
                name: 'varFSubparam3'
              }}
            >
              {menuSubparams}
            </Select>
          </FormControl>
        }
      </div >
    );
  }
}